export default __webpack_public_path__ + "static/media/sparkling.8a7dba79.png";